import { Link, useLocation } from 'react-router-dom'
import './PageNavigation.css'

// Define the navigation order for all pages
const navigationOrder = [
  { path: '/', title: 'Welcome to Aedify.AI' },
  { path: '/quick-start', title: 'Quick Start' },
  { path: '/platform-capabilities/apps', title: 'Apps' },
  { path: '/platform-capabilities/registry', title: 'Registry' },
  // { path: '/platform-capabilities/cloud-storage', title: 'Cloud Storage' }, // Hidden for now
  { path: '/platform-capabilities/database', title: 'Database' },
  { path: '/platform-capabilities/vps', title: 'VPS' },
  { path: '/account/billing', title: 'Billing' },
  { path: '/account/usage', title: 'Usage' },
  { path: '/resources/api-keys', title: 'API Keys' },
  { path: '/resources/vscode-extension', title: 'VS Code Extension' },
  { path: '/resources/faq', title: 'FAQ' },
  { path: '/resources/support', title: 'Support' },
  { path: '/resources/community', title: 'Community' }
]

const PageNavigation = () => {
  const location = useLocation()
  const currentPath = location.pathname
  const currentIndex = navigationOrder.findIndex(page => page.path === currentPath)
  
  const previousPage = currentIndex > 0 ? navigationOrder[currentIndex - 1] : null
  const nextPage = currentIndex < navigationOrder.length - 1 ? navigationOrder[currentIndex + 1] : null

  if (!previousPage && !nextPage) {
    return null // Don't show navigation if there's no previous or next page
  }

  return (
    <nav className="page-navigation">
      <div className="page-nav-container">
        {previousPage ? (
          <Link to={previousPage.path} className="page-nav-button page-nav-prev">
            <div className="page-nav-label">Previous</div>
            <div className="page-nav-title">« {previousPage.title}</div>
          </Link>
        ) : (
          <div className="page-nav-button page-nav-prev page-nav-disabled">
            <div className="page-nav-label">Previous</div>
            <div className="page-nav-title"></div>
          </div>
        )}
        
        {nextPage ? (
          <Link to={nextPage.path} className="page-nav-button page-nav-next">
            <div className="page-nav-label">Next</div>
            <div className="page-nav-title">{nextPage.title} »</div>
          </Link>
        ) : (
          <div className="page-nav-button page-nav-next page-nav-disabled">
            <div className="page-nav-label">Next</div>
            <div className="page-nav-title"></div>
          </div>
        )}
      </div>
    </nav>
  )
}

export default PageNavigation
